import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import * as ApiRouter from 'constants/apiRouting'
import Psfs from 'lib/psfs/Psfs'
import { SHOW_NOTICE } from '../notice'
import {
  FETCH_USER_GROUP_LIST,
  SUCCESS_USER_GROUP_LIST,
  FAILURE_USER_GROUP_LIST,
  LOAD_USER_GROUP_LIST,
  FETCH_USER_GROUP_TABLE,
  SUCCESS_USER_GROUP_TABLE,
  FAILURE_USER_GROUP_TABLE,
  LOAD_USER_GROUP_TABLE,
  FETCH_USER_GROUP_FORM,
  SUCCESS_USER_GROUP_FORM,
  FAILURE_USER_GROUP_FORM,
  LOAD_USER_GROUP_FORM,
  SET_USER_GROUP_INFO,
  DELETE_USER_GROUP_INFO,
} from './reducer'

function* fetchUserGroupList(action) {
  try {
    const { psfs, licensee, site } = action.payload
    let partUrl = `${ApiRouter.USER_GROUPS}${UrlHelper.getPsfsQuery({ psfs })}`

    if (licensee) {
      partUrl += `&licensee=${licensee}`
    }

    if (site) {
      partUrl += `&site=${site}`
    }

    yield put({ type: LOAD_USER_GROUP_LIST, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl,
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_USER_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_USER_GROUP_LIST })
    }

    yield put({ type: LOAD_USER_GROUP_LIST, payload: false })
  } catch (error) {
    console.log('LOAD USER GROUP LIST ERROR', error)
  }
}

function* fetchUserGroupTable(action) {
  try {
    yield put({ type: LOAD_USER_GROUP_TABLE, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.USER_GROUP_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!Object.prototype.hasOwnProperty.call(response, 'error')) {
      yield put({
        type: SUCCESS_USER_GROUP_TABLE,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_USER_GROUP_TABLE })
    }

    yield put({ type: LOAD_USER_GROUP_TABLE, payload: false })
  } catch (error) {
    console.log('LOAD USER GROUP TABLE ERROR', error)
  }
}

function* fetchUserGroupForm({ payload }) {
  try {
    yield put({ type: LOAD_USER_GROUP_FORM, payload: true })

    const { entityId } = payload
    const formData = {
      users: [],
      applications: [],
      userGroup: null,
    }
    const psfs = new Psfs().addFilter('enabled', true)
    const psfsApp = new Psfs().addFilter('active', true)

    formData.users = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.USERS}${UrlHelper.getPsfsQuery({ psfs })}`,
    })

    formData.applications = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.APPLICATIONS_BY_LICENSEE}${UrlHelper.getPsfsQuery({
        psfsApp,
      })}`,
    })

    if (entityId) {
      formData.userGroup = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(ApiRouter.USER_GROUP_INFO, {
          id: entityId,
        }),
      })
    }

    if (
      !formData.userGroup ||
      !Object.prototype.hasOwnProperty.call(formData.userGroup, 'error')
    ) {
      yield put({
        type: SUCCESS_USER_GROUP_FORM,
        payload: formData,
      })
    } else {
      yield put({ type: FAILURE_USER_GROUP_FORM })
    }

    yield put({ type: LOAD_USER_GROUP_FORM, payload: false })
  } catch (error) {
    console.log('LOAD USER GROUP FORM ERROR', error)
  }
}

function* setUserGroupInfo({ payload, promise }) {
  try {
    const { entityId, values } = payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: !entityId
        ? ApiRouter.USER_GROUPS
        : UrlHelper.create(ApiRouter.USER_GROUP_INFO, { id: entityId }),
      method: !entityId ? 'POST' : 'PUT',
      data: values,
    })

    if (response.error) {
      return yield call(promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `User group ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(promise.resolve, false)
  } catch (error) {
    throw new Error(`USER GROUP CHANGE ERROR. DATA: ${error}`)
  }
}

function* deleteUserGroupInfo(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRouter.USER_GROUP_INFO, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('User group delete successful'),
      })

      return yield fetchUserGroupTable(action)
    }
  } catch (error) {
    console.log('USER GROUP INTERFACE ERROR', error)
  }
}

function* userGroupSaga() {
  yield takeLatest(FETCH_USER_GROUP_LIST, fetchUserGroupList)
  yield takeLatest(FETCH_USER_GROUP_TABLE, fetchUserGroupTable)
  yield takeLatest(FETCH_USER_GROUP_FORM, fetchUserGroupForm)
  yield takeLatest(SET_USER_GROUP_INFO, setUserGroupInfo)
  yield takeLatest(DELETE_USER_GROUP_INFO, deleteUserGroupInfo)
}

export default userGroupSaga
